var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 31.5999C24.7599 31.5999 31.5999 24.4799 31.5999 15.9999C31.5999 7.2799 24.7199 0.399902 15.9999 0.399902C7.2799 0.399902 0.399902 7.2799 0.399902 15.9999C0.399902 24.7199 7.2799 31.5999 15.9999 31.5999ZM7.4399 15.4799L9.6799 13.2399L14.6399 18.1599L23.4399 9.3999L25.6799 11.6399L14.6399 22.7199L7.4399 15.4799Z",
    fill: "#6EC85C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneIcon);
export default __webpack_public_path__ + "static/media/done-icon.176fd2c10c52379860f5757d5b2d7dee.svg";
export { ForwardRef as ReactComponent };